<template>
  <div class="home">
    <div class="text-xl md:text-4xl text-center mt-16 px-4 md:px-0">
      <div v-if="showLeaderboard">
        <img
          class="mx-auto md:mx-0"
          src="../assets/img/LeaderboardTittle.svg"
          alt="Leaderboard"
        />
      </div>
      <div v-if="!showLeaderboard">
        <img
          class="mx-auto md:mx-0"
          src="../assets/img/DeathValleyTittle.svg"
          alt="Leaderboard"
        />
      </div>
      <p class="md:text-xl text-lg">
        <!-- If a vNFT is dead you'll see a skull by his position. You can claim 60%
        of it's points by being the first that clicks on the skull (costs gas
        for the tx) -->
      </p>
    </div>
    <div
      class="flex w-full md:flex-row flex-col items-center justify-center md:justify-between"
    >
      <div class="mt-8 flex px-0 items-center text-black">
        <div
          class="cursor-pointer border-gray-900 hover:text-white"
          @click="toggleLeaderboard('leaderboard')"
          :class="{ 'border-b-4': showLeaderboard }"
        >
          Leaderboard
        </div>
        <div
          class="ml-6 cursor-pointer border-gray-900 hover:text-white"
          @click="toggleLeaderboard"
          :class="{ 'border-b-4': showDeadNfts }"
        >
          Death Valley
        </div>
      </div>

      <div class="mt-8 flex cursor-pointer rounded border">
        <!-- <t-select
          :options="types"
          v-model="type"
          class="border-dark border rounded px-2 focus:outline-none pr-8 h-8 text-lg font-light"
        /> -->
      </div>
    </div>
    <div
      class="flex flex-col space-x-0 mt-4 flex-nowrap overflow-y-hidden overflow-x-auto"
    >
      <div class="mt-4">
        <div class="flex flex-wrap" v-if="showLeaderboard">
          <div
            class="sm:w-2/4 md:w-6/12 lg:w-3/12 w-full pb-4 mx-auto"
            v-for="(nft, index) in leaderBoard"
            :key="nft.player_id"
            v-on:click="clickNFT(nft.player_id)"
          >
            <NFT
              :contract="nft.contract"
              :id="nft.player_id"
              :nft="nft"
              :position="index + 1"
              :leaderboard="true"
            />
          </div>
        </div>

        <div
          class="fixed z-30 bottom-0 left-0 w-full pb-4 pl-0 md:px-6 md:py-6 md:pt-8 rounded-2xl rounded-l-none rounded-b-none md:bg-gradient-to-r from-gray-800 md:bg-opacity-50 md:shadow-lg"
          v-if="showLeaderboard"
        >
          <Battle />
        </div>
      </div>

      <div v-if="!showLeaderboard" class="flex justify-between flex-wrap">
        <div
          class="sm:w-2/4 md:w-6/12 lg:w-3/12 w-full pb-4 mx-auto"
          v-for="(nft, index) in deadVnfts"
          :key="nft.id"
          v-on:click="clickNFT(nft.id)"
        >
          <NFT
            :showDeadNfts="showDeadNfts"
            :contract="nft.contract"
            :id="nft.player_id"
            :nft="nft"
            :position="index + 1"
            :leaderboard="true"
          />
        </div>
        <div
          class="text-4xl mt-8"
          v-if="!deadVnfts.length > 0 && !showLeaderboard"
        >
          No dead players were found.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NFT from "@/components/NFT.vue";
import Battle from "@/components/Battle.vue";

export default {
  name: "Leaderboard",
  components: {
    NFT,
    Battle,
  },
  data: function () {
    return {
      leaderBoard: [],
      deadVnfts: [],
      showLeaderboard: true,
      showDeadNfts: false,
      type: "all",
      types: {
        all: "All",
        "57f0b53926dd62f2e26bc40b30140abea474da94": "vNFT",
        e4605d46fd0b3f8329d936a8b258d69276cba264: "Meme Ltd",
      },
    };
  },
  created: function () {
    this.refreshLeaderBoard();
  },
  methods: {
    clickNFT: function (id) {
      this.$router.push({ name: "vNFT", params: { id: id } });
    },
    refreshLeaderBoard: async function () {
      const result = await axios.get(`https://api.nft20.io/game/leaderboard`);

      for (const nft of result.data) {
        this.leaderBoard.push(nft);
      }

      const death_result = await axios.get(
        `https://api.nft20.io/game/deathvalley`
      );
      // const deathresult = await axios.get(
      //   `https://gallery.verynifty.io/api/leaderboard/starving?type=${this.type}`
      // );

      for (const nft of death_result.data) {
        this.deadVnfts.push(nft);
      }
    },
    toggleLeaderboard: function (tab) {
      if (tab == "leaderboard") {
        this.showLeaderboard = true;
        this.showDeadNfts = false;
        document.body.className = document.body.className.replace(
          "deathvalley",
          ""
        );
      } else {
        this.showLeaderboard = false;
        this.showDeadNfts = true;
        document.body.className = "deathvalley";
      }
    },
  },
  beforeMount: function () {
    // this.refreshLeaderBoard();
  },
  beforeCreate: function () {},
  beforeDestroy: function () {
    document.body.className = document.body.className.replace(
      "deathvalley",
      ""
    );
  },
  mounted: function () {},
  computed: {},
  watch: {
    page: function () {
      this.refreshLeaderBoard();
    },
    type: function () {
      this.refreshLeaderBoard();
    },
  },
};
</script>

<style scoped>
/* body {
  background: url("~@/assets/img/bg_img1.svg") no-repeat bottom center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
} */
</style>
